import React from 'react';
import {
  Box,
  IconButton,
  Tooltip
} from '@material-ui/core';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import minusFill from '@iconify/icons-eva/minus-fill';
import refreshOutline from '@iconify/icons-eva/refresh-outline';

const ZoomControls = ({
  zoom,
  onZoomIn,
  onZoomOut,
  onReset,
  minZoom = 0.5,
  maxZoom = 3,
  disabled = false
}) => {
  const canZoomIn = zoom < maxZoom;
  const canZoomOut = zoom > minZoom;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 8,
        right: 8,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderRadius: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        p: 0.5,
        zIndex: 10,
        backdropFilter: 'blur(4px)'
      }}
    >
      <Tooltip title="Zoom In" placement="left">
        <IconButton
          size="small"
          onClick={onZoomIn}
          disabled={disabled || !canZoomIn}
          sx={{
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.04)'
            }
          }}
        >
          <Icon
            icon={plusFill}
            width={20}
            height={20}
            color={disabled || !canZoomIn ? 'text.disabled' : 'text.primary'}
          />
        </IconButton>
      </Tooltip>

      <Tooltip title="Zoom Out" placement="left">
        <IconButton
          size="small"
          onClick={onZoomOut}
          disabled={disabled || !canZoomOut}
          sx={{
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.04)'
            }
          }}
        >
          <Icon
            icon={minusFill}
            width={20}
            height={20}
            color={disabled || !canZoomOut ? 'text.disabled' : 'text.primary'}
          />
        </IconButton>
      </Tooltip>

      <Tooltip title="Reset Zoom" placement="left">
        <IconButton
          size="small"
          onClick={onReset}
          disabled={disabled || zoom === 1}
          sx={{
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.04)'
            }
          }}
        >
          <Icon
            icon={refreshOutline}
            width={20}
            height={20}
            color={disabled || zoom === 1 ? 'text.disabled' : 'text.primary'}
          />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ZoomControls;
